// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__13G_k","empty":"ModalGraph_empty__2jPZj"};